import React, { ReactNode, useEffect, useState } from "react";
import { Dialog, Paper, Box, Container, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';

function ModalWithCloseButton({
  children,
  open,
  handleClose,
}: {
  children: ReactNode;
  open: boolean;
  handleClose: any;
}) {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        sx: {
          width: "100%",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <Container sx={{ backgroundColor: "transparent" }} disableGutters>
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "right" }}
          mb={6}
        >
          <IconButton
            data-testid="closeButton"
            onClick={handleClose}
            color="error"
            sx={{ backgroundColor: "white" }}
          >
            <CloseIcon />
            {/* <HighlightOffIcon/> */}
          </IconButton>
        </Box>
        <Paper
          sx={{
            width: "100%",
            borderRadius: "16px",
            minHeight: "100px",
          }}
          data-testid="modalWithOpenChildren"
        >
          {children}
        </Paper>
      </Container>
    </Dialog>
  );
}

export default ModalWithCloseButton;
